import { render, staticRenderFns } from "./LControlPlan.vue?vue&type=template&id=6674c886&scoped=true&"
import script from "./LControlPlan.vue?vue&type=script&lang=js&"
export * from "./LControlPlan.vue?vue&type=script&lang=js&"
import style0 from "./LControlPlan.vue?vue&type=style&index=0&id=6674c886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6674c886",
  null
  
)

export default component.exports